import { handleExportToShare } from '~core/actions/handleExportToShare';

export const onShareCanvasBtnClick = async (event) => {
  event.preventDefault();
  await handleExportToShare();
};
